import { createSlice } from '@reduxjs/toolkit';
import { addExtraReducer } from '../../utils/addExtraReducer';
import initialState from './initialState';
import { GetTobaccoTransactionsReducer, ResetTobaccoTransactionsStateReducers } from './reducers';
import { GetTobaccoTransactions } from './thunks';

// ----------------------------------------------------------------------------

// slice
export const slice = createSlice({
  name: 'tobaccoTransactions',
  initialState,
  reducers: {
    ResetTobaccoTransactionsState: ResetTobaccoTransactionsStateReducers,
  },
  extraReducers: (builder) => {
    addExtraReducer(builder, GetTobaccoTransactions, GetTobaccoTransactionsReducer);
  },
});

export default slice.reducer;
